// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Y63k3"};